import { render, staticRenderFns } from "./GiftBoxCampaignsBatchDetailModal.vue?vue&type=template&id=79d86109&scoped=true&"
import script from "./GiftBoxCampaignsBatchDetailModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsBatchDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d86109",
  null
  
)

export default component.exports